import { render, staticRenderFns } from "./UserRecentStudyPage.vue?vue&type=template&id=1576ef72&scoped=true"
import script from "./UserRecentStudyPage.vue?vue&type=script&lang=js"
export * from "./UserRecentStudyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1576ef72",
  null
  
)

export default component.exports